import { render, staticRenderFns } from "./anchorPoint.vue?vue&type=template&id=34de515c&scoped=true&"
import script from "./anchorPoint.vue?vue&type=script&lang=js&"
export * from "./anchorPoint.vue?vue&type=script&lang=js&"
import style0 from "./anchorPoint.vue?vue&type=style&index=0&id=34de515c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34de515c",
  null
  
)

export default component.exports